export const range = function* (min: number, max: number) {
  for (let n = min; n < max; ++n) {
    yield n;
  }
};
